import { createSlice, configureStore } from "@reduxjs/toolkit";
import videoDefaultData from "./videoData.json";

const defaultData = {
  idx: 0,       // 雙影片使用的索引
  playmode: 1,  // 播放模式
  'video1': videoDefaultData,
  'video2': videoDefaultData,
}

const videoSlice = createSlice({
  name: "VideoDisplay",
  initialState: defaultData,
  reducers: {
    resetVideoDisplayData: (state, action) => {
      return defaultData;
    },
    set_Video1_DisplayData: (state, action) => {
      state.video1 = action.payload
    },
    set_Video1_DisplayAngle: (state, action) => {
      state.video1.view = action.payload;
    },
    set_Video1_DisplaySRC: (state, action) => {
      state.video1.src = action.payload;
    },
    set_Video2_DisplayData: (state, action) => {
      state.video2 = action.payload
    },
    set_Video2_DisplayAngle: (state, action) => {
      state.video2.view = action.payload;
    },
    set_Video2_DisplaySRC: (state, action) => {
      state.video2.src = action.payload;
    },
    set_Video_idx: (state, action) => {
      state.idx = action.payload;
    },
    set_PlayMode: (state, action) => {
      state.playmode = action.payload;
    }
  },
});

export const {
  resetVideoDisplayData,
  set_Video1_DisplayData,
  set_Video1_DisplayAngle,
  set_Video1_DisplaySRC,
  set_Video2_DisplayData,
  set_Video2_DisplayAngle,
  set_Video2_DisplaySRC,
  set_Video_idx,
  set_PlayMode
} = videoSlice.actions;

export const videoStore = configureStore({
  reducer: videoSlice.reducer,
});
